import React from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';

const Hero = ({ title, subtitle, buttonText, buttonLink, backgroundImage, isHomePage }) => {
  const backgroundStyle = {
    backgroundImage: `linear-gradient(rgba(4,9,30,0.7), rgba(4,9,30,0.7)), url("${backgroundImage}")`,
    backgroundRepeat: 'no-repeat',
  };

  return (
    <div className={`hero ${isHomePage ? 'hero-home' : ''}`} style={backgroundStyle}>
      <div className="hero-content">
        <h1>{title}</h1>
        {subtitle && <p>{subtitle}</p>}
        {buttonText && buttonLink && (
          <Link to={buttonLink} className="btn">
            {buttonText}
          </Link>
        )}
      </div>
    </div>
  );
};

export default Hero; 